<template>
    <!-- 线下门店核销码，用于线下签到 -->
    <van-popup v-if="popupVisible"
        v-model="popupVisible"
        :close-on-click-overlay="false"
        class="popup">
        <div class="outer-wrapper">
            <!-- 二维码 -->
            <div class="qr-code">
                <img v-if="qrCodeUrl"
                    :src="qrCodeUrl" />
            </div>
            <div class="refresh"
                @click="refreshQrCode(true)">
                <img src="../../../../../static/runtime/images/magic/refresh-icon.png" />
                <span>刷新二维码</span>
            </div>
            <div class="tips">请到指定荣耀门店出示二维码，店员扫码后完成签到；点击查看具体活动门店名单</div>
            <div class="view-btn"
                @click="goStoreNavigation">查看活动门店</div>
            <!-- 关闭图标 -->
            <div class="close-icon"
                @click="close">
                <img src="../../../../../static/runtime/images/magic/close-icon.png" />
            </div>
        </div>
    </van-popup>
</template>
<script >
import { Popup, Dialog } from 'vant';
const MAX_RETRY = 15; // 最大重试次数
export default {
  name: 'OfflineCheckQrCode',
  components: {
    [Popup.name]: Popup,
  },
  props: {
    // 活动编码
    activityCode: {
      type: String,
      default: '',
    },
    // 登录类型
    loginType: {
      type: String,
      default: '',
    },
    //位置信息
    positionInfo: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      qrCodeUrl: '',
      popupVisible: false,
      itemObj: {},
      count: 0, // 查询扫码状态计数，最多查询15次（二维码已失效），超过15次不再继续查询，刷新二维码之后重置为0
      isSearching: false, // 是否正在查询中
    };
  },
  methods: {
    open(item) {
      this.itemObj = Object.assign({}, item);
      this.count = 0;
      this.init();
    },
    close() {
      this.popupVisible = false;
      this.count = 0;
    },
    init() {
      //1.获取二维码
      this.refreshQrCode()
        .then(() => {
          //2.循环查询查询扫码状态
          this.checkScanStatus();
        })
        .catch((err) => {
          this.popupVisible = false;
          Dialog.alert({
            message: err.message || '活动过于火爆，请稍后再试',
          }).then(() => {
            this.$emit('refresh');
          });
        });
    },
    // 刷新二维码
    refreshQrCode(hand = false) {
      return new Promise((resolve, reject) => {
        const param = {
          id: this.itemObj.id, // checkInfo里面的奖项列表对应的id
          activityCode: this.activityCode,
          loginType: this.loginType,
          longitude: this.positionInfo.longitude,
          dimension: this.positionInfo.latitude,
          coordinateType: this.positionInfo.coordinateType,
        };
        this.$api.post({
          sc: 'mobileMarketing',
          url: `/h5/checkin/generateRewardQR`,
          params: param,
          success: (res) => {
            if (res.code === 200) {
              if (res.result.qrBaes) {
                this.popupVisible = true;
                this.qrCodeUrl = 'data:image/png;base64,' + res.result.qrBaes;
              } else {
                this.popupVisible = false;
                this.$emit('refresh');
              }
              this.count = 0;
              // 手动刷新，没有正在查询扫码状态，则主动发起一次
              if (hand && !this.isSearching) {
                this.checkScanStatus();
              }
              resolve(true);
            } else {
              this.popupVisible = false;
              reject(res);
            }
          },
          failure: (err) => {
            reject(err);
          },
        });
      });
    },
    // 跳转门店导航
    goStoreNavigation() {
      this.$router.push({
        path: `/hdmain?activityCode=${this.itemObj.navigateCode}`,
      });
      console.log('跳转=====>');
      this.close();
    },
    // 查询扫码状态
    checkScanStatus() {
      if (this.isSearching) {
        return;
      }
      this.isSearching = true;
      const param = {
        id: this.itemObj.id, // checkInfo里面的奖项列表对应的id
        activityCode: this.activityCode,
      };
      console.log('count', this.count);
      this.count++;
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkin/getRewardCheckinResult`,
        params: param,
        success: async (res) => {
          if (res.code === 200 && res.result && res.result.bigwheelRewardRecordDetailsDtoList) {
            const result = res.result.bigwheelRewardRecordDetailsDtoList;
            this.isSearching = false;
            this.$emit('checkInSuccess', result);
            this.close();
          } else {
            if (this.count < MAX_RETRY && this.popupVisible) {
              // 未签到成功，等待两秒之后，继续查询
              console.log('waiting', new Date().getSeconds());
              await this.wait();
              this.isSearching = false;
              console.log('next', new Date().getSeconds());
              this.checkScanStatus();
            } else {
              this.isSearching = false;
            }
          }
        },
        failure: (err) => {
          this.isSearching = false;
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
    },
    // 等待函数
    wait(time = 2000) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, time);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.popup {
  height: 100%;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
}
.outer-wrapper {
  width: 313px;
  background: #ffffff;
  border-radius: 12px;
  position: relative;
  .qr-code {
    margin: 14px auto;
    margin-top: 35px;
    width: 187px;
    height: 187px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .refresh {
    font-family: HONORSansBrand-Regular;
    font-size: 14px;
    color: #256fff;
    text-align: center;
    font-weight: 400;
    margin-bottom: 14px;
    img {
      width: 15px;
      margin-bottom: -1px;
    }
  }
  .tips {
    font-family: HONORSansBrand-Regular;
    font-size: 14px;
    color: #000000;
    text-align: center;
    font-weight: 400;
    width: 254px;
    margin: 0 auto;
    line-height: 1.3;
  }
  .view-btn {
    height: 44px;
    width: 225px;
    border-radius: 22px;
    background-color: #2e71fa;
    color: #ffffff;
    line-height: 44px;
    text-align: center;
    margin: 0 auto;
    font-size: 15px;
    margin-top: 20px;
    margin-bottom: 26px;
  }
  .close-icon {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    color: white;
    font-size: 23px;
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 150%);
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/sign-in-components/offline-check-qr-code.vue